module.exports = __webpack_public_path__ + "static/media/danskeheadline-webfont.62d2fb80.svg";